import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=db1cc42c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1cc42c')) {
      api.createRecord('db1cc42c', component.options)
    } else {
      api.reload('db1cc42c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=db1cc42c&", function () {
      api.rerender('db1cc42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ash9XZ3QUqes/JS/comp/childrenage.vue"
export default component.exports